import { h } from "preact";
import BlogSort from "./blog-sort";
import "../helpers/scroll-tracker";

export default function BlogNav({
  blogUrl,
  tags,
  tag,
  setTag,
  reverse,
  setReverse,
}) {
  const handleUpdateTag = (e, newTag) => {
    e.preventDefault();
    setTag(newTag);

    const newUrl = new URL(e.target.href);
    newUrl.searchParams.set("sort_by", reverse ? "oldest" : "newest");
    window.history.pushState(null, "", newUrl);
  };

  return (
    <div className="main-blog__nav-wrapper">
      <div className="main-blog__nav">
        <scroll-tracker className="main-blog__tags-wrapper">
          <ul className="main-blog__tags">
            <li>
              <a
                className={`main-blog__tag ${
                  tag === null ? "main-blog__tag--active" : ""
                }`}
                href={blogUrl}
                onClick={(e) => handleUpdateTag(e, null)}
                key={tag}
              >
                View All
              </a>
            </li>
            {tags.map((tagItem) => (
              <li>
                <a
                  className={`main-blog__tag ${
                    tagItem === tag ? "main-blog__tag--active" : ""
                  }`}
                  href={`${blogUrl}/tagged/${window.handleize(tagItem)}`}
                  onClick={(e) => handleUpdateTag(e, tagItem)}
                  key={tagItem}
                >
                  {tagItem}
                </a>
              </li>
            ))}
          </ul>
        </scroll-tracker>
        <BlogSort reverse={reverse} setReverse={setReverse} />
      </div>
    </div>
  );
}
